export const searchDefault = {
  keyword: "",
  country: "",
};
